import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Grid, OutlinedInput } from '@material-ui/core';
import * as statisticsActionMgr from '../action-mgr';
import * as statisticsReducers from '../reducer';
import * as strings from '../../helpers/strings';

const styles = {
  formControlWrapper: { marginBottom: 15 },
  formControlWrapperSelectMenu: {
    '& > div > div': {
      boxShadow:
        '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    },
  },
};

class StationBiDirectionalSelect extends React.Component {
  componentDidMount() {
    const { loggedInUser, setSelectBiDirectionalStation, selectedBiDirectionalStation } = this.props;
    const biDirectionalStations = loggedInUser?.biDirectionalStationList || [];

    // Automatically select the first bi-directional station if none is selected
    if (biDirectionalStations.length > 0 && !selectedBiDirectionalStation) {
      setSelectBiDirectionalStation(biDirectionalStations[0].name);
    }
  }

  handleStationChange = (event) => {
    const {
      setSelectBiDirectionalStation,
      updateBiDirectionalEnergyFilter,
      resetBiDirectionalData,
      resetStatisticsView,
      resetStatisticsDateSelections,
    } = this.props;

    const selectedStationName = event.target.value;

    // Update the selected station in Redux
    setSelectBiDirectionalStation(selectedStationName);

    // Reset dependent state for fresh data
    updateBiDirectionalEnergyFilter({ facilities: [], type: 'all', time: '' });
    resetBiDirectionalData();
    resetStatisticsView();
    resetStatisticsDateSelections();
  };

  render() {
    const { selectedBiDirectionalStation, loggedInUser, classes } = this.props;

    const biDirectionalStations = loggedInUser?.biDirectionalStationList || [];

    return (
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <FormControl
            className={classes.formControlWrapper}
            variant={strings.txtOutlined}
            fullWidth
          >
            <InputLabel htmlFor={strings.idSelectStation}   >
              {strings.lblStation}
            </InputLabel>
            <Select
            value={selectedBiDirectionalStation || ''}
            onChange={this.handleStationChange}
            input={
                <OutlinedInput
                labelWidth={150}
                name={strings.lblStation}
                id={strings.idSelectStation}
                key="biDirectionalStationSelect"
                className={classes.formControlWrapperSelectMenu}
                />
            }
            
            disabled={biDirectionalStations.length === 0}
            >
            {biDirectionalStations.length === 0 ? (
                <MenuItem disabled value="">
                No bi-directional stations assigned
                </MenuItem>
            ) : (
                biDirectionalStations
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((station) => (
                    <MenuItem key={station.name} value={station.name}>
                    {station.name} — {station.description}
                    </MenuItem>
                ))
            )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: state.system?.loggedInUser || {}, 
  selectedBiDirectionalStation: statisticsReducers.getSelectedBiDirectionalStation(state),
});

const mapActionsToProps = {
  setSelectBiDirectionalStation: statisticsActionMgr.setSelectBiDirectionalStation,
  updateBiDirectionalEnergyFilter: statisticsActionMgr.updateBiDirectionalEnergyFilter,
  resetBiDirectionalData: statisticsActionMgr.resetBiDirectionalData,
  resetStatisticsView: statisticsActionMgr.resetStatisticsView,
  resetStatisticsDateSelections: statisticsActionMgr.resetStatisticsDateSelections,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(StationBiDirectionalSelect)
);
